import { SxProps, Theme } from "@mui/material/styles";
import theme from "../../theme";

const styles: SxProps<Theme> = [
  {
    "&.root": {
      boxShadow: "none",
      borderRadius: "2px",
      textTransform: "none",
      "& .iconLeft": {
        marginRight: 16,
      },
      "& .iconRight": {
        marginLeft: 16,
      },
      "&:hover, &:focus, &:active": {
        boxShadow: "none",
      },
    },
    "&.containedPrimary": {
      boxShadow:
        " 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14)",
      textTransform: "none",
      fontSize: 13,
      color: "#000",
      fontWeight: "bold",
    },

    "&.textInherit": {
      background: "transparent",
      color: theme.palette.text.primary,
      p: "6px 16px",
      fontWeight: 400,
      "&:hover": {},
      "&.sizeSmall": {
        background: "transparent",
        color: theme.palette.text.primary,
        fontWeight: 400,
        fontSize: 12,
        ml: 1,
        "& .icon": {
          background: "transparent",
          mr: 0,
          "& svg": {
            width: 20,
          },
        },
        "&:hover, &:focus, &:active": {
          textDecoration: "underline",
        },
      },
    },

    "&.iconButton": {
      background: "transparent",
      boxShadow: "none",
      padding: 0,
      fontWeight: "bold",
      textTransform: "none",
      color: theme.palette.grey[900],
      fontSize: "1.1em",
      "&:hover, &:focus, &:active": {
        background: "transparent",
      },
    },
    "& .icon": {
      background: theme.palette.primary.main,
      borderRadius: "100%",
      width: 30,
      height: 30,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    "& .prevIcon": {
      marginRight: "12px",
    },
    "& .nextIcon": {
      marginLeft: "12px",
    },
  },
];

export default styles;
